import React, { Component } from 'react';
import styled from 'styled-components';

import withFieldWrapper from '../../hocs/withFieldWrapper';

const Input = styled.input`
    outline: 0;
    display: block;
    width: 100%;
    height: 40px;
    padding: 10px 16px;
    font-size: 16px;
    background-color: #ededed;
    border: 1px solid transparent;
    font-weight: bold;
    color: #2b3d4f;
    background-image: none;
    appearance: none;
`;

class NumberInput extends Component {
    onChange = e => this.props.onChange(Number(e.target.value));

    render() {
        const { disabled, input: { value }, placeholder } = this.props;

        return <Input
            type='number'
            disabled={disabled}
            value={value}
            placeholder={placeholder}
            onChange={this.onChange}
            min={0} />
    }
}

export default withFieldWrapper(NumberInput);
